"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ItemBpBv = void 0;
var _mui = require("@ori-ui/mui");
var _tsUtils = require("@ori/ts-utils");
var _context = require("../../context");
var _FormattedMessage = require("../internal/FormattedMessage");
var _style = require("./style");
var _jsxRuntime = require("react/jsx-runtime");
const ItemBpBv = () => {
  const {
    bp,
    bv,
    itemTestId,
    showBp
  } = (0, _context.useItemContext)();
  const theme = (0, _mui.useTheme)();
  if (showBp && (bp !== '' || (0, _tsUtils.isNonNullable)(bv))) {
    return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_style.NumberInner, {
      children: [bp === '' ? null : /*#__PURE__*/(0, _jsxRuntime.jsx)(_style.NumberInnerValue, {
        variant: "caption",
        color: theme.palette.text.secondary,
        "data-testid": `${itemTestId}-bp`,
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_FormattedMessage.FormattedMessage, {
          id: "bpCount",
          defaultMessage: "{0} BP",
          values: {
            0: bp
          }
        })
      }), (0, _tsUtils.isNonNullable)(bv) ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_style.NumberInnerValue, {
        variant: "caption",
        "data-testid": `${itemTestId}-bv`,
        color: theme.palette.text.secondary,
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_FormattedMessage.FormattedMessage, {
          id: "bvCount",
          defaultMessage: "{0} BV",
          values: {
            0: bv
          }
        })
      }) : null]
    });
  }
  return null;
};
exports.ItemBpBv = ItemBpBv;
